/**
 * The cover drawing family — the ids `CoverAnimation.vue` draws.
 *
 * The hub declares `settings.cover_style` on its cover class (the behavioural
 * `cover_type` is already taken by shutter vs jalousie); a device saved
 * before that keeps the choice in its icon/name, which `coverKindOf` still reads.
 */
import { coverKindOf } from '../../devices/deviceWidgetTypes';
import { variantFromSetting, variantValues, type VariantFamily } from './types';

export const COVER_VARIANTS: VariantFamily = {
  drawing: 'cover',
  settingKey: 'cover_style',
  title: ['Cover type', 'Vrsta senčila'],
  description: [
    'The shade this is. The tile draws it; the controls stay the same.',
    'Vrsta tega senčila. Ploščica ga nariše; upravljanje ostane enako.',
  ],
  options: [
    { value: 'auto', icon: 'settings_suggest', label: ['Automatic', 'Samodejno'] },
    { value: 'roller', icon: 'roller_shades', label: ['Roller blind', 'Roleta'] },
    { value: 'venetian', icon: 'blinds', label: ['Venetian blind', 'Žaluzija'] },
    { value: 'shutter', icon: 'blinds_closed', label: ['Shutter', 'Rolo'] },
    { value: 'screen', icon: 'curtains', label: ['Sun screen', 'Senčilo'] },
    { value: 'lamella', icon: 'roofing', label: ['Lamella roof', 'Lamela'] },
    { value: 'awning', icon: 'umbrella', label: ['Awning', 'Markiza'] },
    { value: 'window', icon: 'window', label: ['Window', 'Okno'] },
  ],
  defaultValue: 'auto',
  resolve: (device) =>
    variantFromSetting(device.settings, 'cover_style', variantValues(COVER_VARIANTS)) ?? coverKindOf(device),
};
